<template>
  <div class="commodityDetail">
    <van-notice-bar
      @click.stop="to"
      @close.stop
      class="loadApp"
      mode="closeable"
      :scrollable="false"
      text="下载未来润美客户端APP"
    />
    <div class="commodityDetail_first">
      <!-- 轮播图 -->
      <div class="pic">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#93683D">
          <van-swipe-item
            v-for="item in commodityDetail.pic_list"
            :key="item.id"
          >
            <img :src="item.pic" alt=""
          /></van-swipe-item>
        </van-swipe>
      </div>
      <div class="commodityDetail_first_content">
        <div class="content_left">
          <div class="title">
            <p class="shop_title">
              {{ commodityDetail.title ? commodityDetail.title : "--" }}
            </p>
            <p class="members">
              <img src="../../assets/img/icon_member@2x.png" alt="" />
            </p>
          </div>

          <div style="display: flex; justify-content: space-between">
            <p class="nowMoney">
              <span>￥</span
              ><span style="font-size: 0.2rem; font-weight: bold">{{
                prePrice
              }}</span
              ><span>{{ minPrice ? minPrice : "" }}</span>
            </p>
            <div
              class="sales"
              style="color: #999a9c; line-height: 0.2rem; font-size: 0.11rem"
            >
              浏览量<span>{{
                commodityDetail.view ? commodityDetail.view : "--"
              }}</span>
            </div>
          </div>
          <p
            class="market_price"
            style="
              height: 0.32rem;
              font-size: 0.12rem;
              text-decoration: line-through;
              color: #999a9c;
              line-height: 0.32rem;
            "
          >
            ￥<span>{{
              commodityDetail.market_price ? commodityDetail.market_price : "--"
            }}</span>
          </p>
        </div>

        <div class="content_bottom">
          <p>
            销量<span>{{
              commodityDetail.buys ? commodityDetail.buys : "--"
            }}</span>
          </p>
          <p style="margin: 0 0.2rem">|</p>
          <p>
            库存<span>{{
              commodityDetail.num == -1 ? "充足" : commodityDetail.num
            }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="commodityDetail_second">
      <div
        class="title"
        style="
          width: 100%;
          height: 0.49rem;
          background: #ffff;
          font-size: 0.12rem;
          color: #333333;
          line-height: 0.49rem;
          padding-left: 0.15rem;
        "
      >
        商品详情
      </div>
      <div v-html="commodityDetail.content" class="detailBox"></div>
      <div class="tabbar">
        <van-tabbar
          v-model="active"
          :route="true"
          inactive-color="#333333"
          active-color="#93683D"
        >
          <van-tabbar-item to="/home" style="flex: 18%">
            <span>首页</span>
            <template #icon="props">
              <img src="../../assets/img/tabbar_img/tab_home@2x.png" />
            </template>
          </van-tabbar-item>
          <van-tabbar-item
            style="flex: 18%"
            @click="iLikeThis(commodityDetail.id, 1)"
          >
            <span>收藏</span>
            <template #icon="props">
              <img
                :src="commodityDetail.like === 1 ? icon.active : icon.inactive"
              />
            </template>
          </van-tabbar-item>
          <van-tabbar-item class="buy" style="flex: 62.6667%" @click="buyit()">
            立即购买
          </van-tabbar-item>
        </van-tabbar>
      </div>
    </div>
    <!-- 圆角弹框 -->
    <van-popup
      v-model="show"
      round
      position="bottom"
      closeable
      :close-icon="require('../../assets/img/popup_btn_close@2x.png')"
      :style="{ height: '4.32rem' }"
    >
      <div class="popup_content">
        <div class="popup_content_shop">
          <div class="shop_pic">
            <img :src="commodityDetail.pic" alt="" />
          </div>
          <div class="shop_right">
            <h2>{{ commodityDetail.title ? commodityDetail.title : "--" }}</h2>
            <p class="shop_dir">
              {{ commodityDetail.desc ? commodityDetail.desc : "--" }}
            </p>
            <p class="shop_price">
              ￥<span style="font-weight: bold; font-size: 0.2rem">{{
                prePrice
              }}</span
              ><span>{{ minPrice }}</span>
            </p>
          </div>
        </div>
        <!-- 加减按钮 -->
        <div class="addSubtract">
          <div class="addSubtract_head">
            <h3 class="num">数量</h3>
            <p>
              {{
                commodityDetail.num == -1
                  ? "库存充足"
                  : "仅剩" + commodityDetail.num + "件"
              }}
            </p>
          </div>
          <!-- 加减按钮 -->
          <div class="addSubtract_btn" style="width: 1.41rem; height: 0.38rem">
            <van-button
              :icon="
                this.num == 1
                  ? require('../../assets/img/icon_reduce_gray@2x.png')
                  : require('../../assets/img/icon_reduce_black@2x.png')
              "
              type="info"
              color="white"
              class="reduce"
              @click="numReduce()"
            >
            </van-button>
            <input type="text" class="number" v-model="num" />
            <van-button
              :icon="
                commodityDetail.num == -1
                  ? require('../../assets/img/icon_plus_black.png')
                  : require('../../assets/img/icon_plus_gray.png')
              "
              type="info"
              color="white"
              class="plus"
              @click="numPluse(commodityDetail.num)"
            >
            </van-button>
          </div>
        </div>
        <div class="btn">
          <van-button
            class="chosen"
            plain
            type="defult"
            :to="{
              name: '确认订单',
              params: {
                commodityDetail: commodityDetail,
                number: num,
                prePrice: prePrice,
                minPrice: minPrice,
              },
            }"
            >选好了</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Title from "@/components/Title";
import bus from "../../utils/eventBus";
import {
  getCommodityDetailList,
  setCollectionState,
  getOrderOklList,
} from "@/api/home";
import { Toast } from "vant";
export default {
  components: {
    Title,
  },
  data() {
    return {
      showIn: true,
      num: 1,
      commodityDetail: {},
      active: 0,
      prePrice: "",
      minPrice: "",
      show: false, // 控制弹框显示
      showShare: false,
      icon: {
        active: require("../../assets/img/tabbar_img/tab_icon_collection_red@2x.png"),
        inactive: require("../../assets/img/tabbar_img/tab_icon_collection@2x.png"),
      },
    };
  },
  created() {
    if (window.location.href.split("?aid=")[1]) {
      localStorage.setItem("otheraid", window.location.href.split("?aid=")[1]);
    }
    getCommodityDetailList({ shop_id: this.$route.params.id })
      .then((res) => {
        if (res.data.code == 0) {
          this.commodityDetail = res.data.backdata;
          // 微信分享
          const config = {
            appId: "wx90d063c3fc548e01",
            shareTitle: this.commodityDetail.title,
            shareTxt: this.commodityDetail.desc,
            shareUrl: this.commodityDetail.share_url,
            imgUrl: this.commodityDetail.pic,
          };
          wxint(config);
          if (this.commodityDetail.user_price == -1) {
            this.prePrice = parseInt(this.commodityDetail.price);
            if (this.commodityDetail.price.includes(".")) {
              this.minPrice = "." + this.commodityDetail.price.split(".")[1];
            } else {
              this.minPrice = "";
            }
          } else {
            this.prePrice = parseInt(this.commodityDetail.user_price);
            if (this.commodityDetail.user_price.includes(".")) {
              this.minPrice =
                "." + this.commodityDetail.user_price.split(".")[1];
            } else {
              this.minPrice = "";
            }
          }
        } else if (res.data.code == 1) {
          Toast(res.data.msg);
          setTimeout(() => {
            this.$router.back();
          }, 2000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  beforeRouteLeave(to, from, next) {
    to.params.activeNum = from.params.activeNum;
    bus.$off("shareEvent");
    next();
  },
  methods: {
    // 在未来润美app中打开
    to() {
      const otheraid = localStorage.getItem("otheraid");
      if (otheraid) {
        window.location.href = this.commonRealmName + "/?aid=" + otheraid;
      } else {
        window.location.href = this.commonRealmName;
      }
    },
    // 点击收藏
    iLikeThis(id, type) {
      if (localStorage.getItem("userToken")) {
        setCollectionState({ shop_id: id, type: type }).then((res) => {
          Toast(res.data.msg);
          if (this.commodityDetail.like === 0) {
            this.commodityDetail.like = 1;
          } else {
            this.commodityDetail.like = 0;
          }
        });
      } else {
        this.$dialog
          .confirm({
            message: "请先登录",
          })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    buyit() {
      if (localStorage.getItem("userToken")) {
        if (this.commodityDetail.user_price == -1) {
          this.show = false;
          Toast("您当前用户组无法购买");
        } else {
          this.show = true;
        }
      } else {
        this.$dialog
          .confirm({
            message: "请先登录",
          })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    // 点击数量增加
    numPluse(val) {
      this.num++;
      if (val != -1 && this.num == val + 1) {
        Toast("库存不足！");
        this.num = val;
      }
    },
    // 点击数量减少
    numReduce() {
      this.num--;
      if (this.num < 1) {
        Toast("至少购买一件哦");
        this.num = 1;
      }
    },
  },
};
</script>

<style lang='scss'>
.commodityDetail {
  padding-top: 0.49rem;
  width: 100%;
  background: rgb(243, 241, 244);
  // 在App中打开
  .van-notice-bar {
    background-color: rgb(255, 255, 255, 0.5);
  }
  .loadApp {
    position: fixed;
    width: 100%;
    z-index: 999;
    height: 0.4rem;
    padding: 0 0.16rem;

    .van-notice-bar__content {
      height: 0.38rem;
      line-height: 0.38rem;
      color: #000000;
      font-size: 0.14rem;
    }
    .van-notice-bar__right-icon {
      font-size: 0.16rem;
    }
  }
  .detailBox {
    img {
      width: 3.75rem;
    }
  }
  .van-notice-bar__content {
    text-indent: 0.35rem;
    background: url("../../assets/img/nav_icon_logo@2x.png") no-repeat center
      left;
    background-size: 0.23rem;
  }
  // 详情页的第一部分
  .commodityDetail_first {
    margin-bottom: 1.1rem;
    width: 100%;
    // 轮播图
    .pic {
      width: 100%;
      height: 3.3rem;
      position: absolute;
      transform: translateX(-50%);
      top: 0.49rem;
      left: 50%;
      // 轮播图上的小圆点
      .van-swipe__indicator--active {
        background: #d2a072 !important;
      }
      .van-swipe__indicators {
        bottom: 0.4rem;
      }
      .my-swipe .van-swipe-item {
        width: 100%;
        height: 3.3rem;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .commodityDetail_first_content {
      position: absolute;
      top: 3.64rem;
      width: 3.75rem;
      background: #ffffff;
      border-radius: 0.2rem 0.2rem 0rem 0rem;
      padding: 0.16rem 0.15rem 0.1rem 0.15rem;
      .content_left {
        p {
          &.shop_title {
            max-width: 2.6rem;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            height: 0.42rem;
            font-size: 0.17rem;
            font-weight: bold;
            color: #333333;
            line-height: 0.42rem;
            margin-right: 0.08rem;
          }
          &.members {
            width: 0.79rem;
            height: 0.17rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .title {
          display: flex;
          height: 0.42rem;
          align-items: center;
        }
        .nowMoney {
          height: 0.22rem;
          font-size: 0.17rem;
          color: #93683d;
          line-height: 0.22rem;
          span {
            font-size: 0.17rem;
            color: #93683d;
          }
        }
      }

      .content_bottom {
        display: flex;
        font-size: 0.12rem;
        color: #999a9c;
        line-height: 0.38rem;
        height: 0.38rem;
      }
    }
  }
  // 详情页的第二部分
  .commodityDetail_second {
    padding-top: 3.8rem;
    .pic {
      width: 100%;
      height: 6.01rem;
    }
  }
  .tabbar {
    width: 100%;
    height: 0.49rem;
    img {
      width: 0.22rem;
      height: 0.22rem;
    }
    .van-tabbar {
      height: 0.49rem;
      .van-tabbar-item {
        .van-tabbar-item__text {
          span {
            display: inline-block;
            transform: scale(0.8);
            font-size: 0.125rem;
          }
        }
        &.buy {
          width: 100%;
          height: 100%;
          background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
          .van-tabbar-item__text {
            font-size: 0.16rem;
            font-weight: bold;
            color: #93683d;
            line-height: 0.12rem;
          }
        }
      }
    }
  }

  .van-overlay {
    position: fixed;
    margin-top: 0.49rem;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background-color: #000000;
    opacity: 0.4;
  }
  // 弹出框里面的内容
  // 关闭按钮
  .van-popup__close-icon--top-right {
    top: 0.29rem;
    right: 0.29rem;
    .van-icon__image {
      font-size: 0.13rem;
    }
  }
  .popup_content {
    padding: 0.29rem 0.29rem 0 0.29rem;

    .popup_content_shop {
      display: flex;
      margin: 0.33rem 0 0.35rem 0;
      .shop_pic {
        width: 1.11rem;
        height: 1.11rem;
        background: #fafafa;
        border-radius: 0.08rem;
        margin-right: 0.19rem;
        img {
          width: 1.11rem;
          height: 1.11rem;
        }
      }
      .shop_right {
        display: flex;
        flex-direction: column;
        width: 1.88rem;
        h2 {
          width: 1.76rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 0.17rem;
          font-weight: bold;
          color: #333333;
          line-height: 0.25rem;
          margin-bottom: 0.1rem;
          margin-right: 0.11rem;
        }
        .shop_dir {
          width: 1.8rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 0.12rem;
          color: #999a9c;
          line-height: 0.2rem;
          margin-bottom: 0.18rem;
        }
        .shop_price {
          height: 0.2rem;
          font-size: 0.17rem;
          color: #93683d;
          line-height: 0.2rem;
        }
      }
    }
    // 加减按钮
    .addSubtract {
      .addSubtract_head {
        display: flex;
        align-items: center;
        height: 0.25rem;
        margin-bottom: 0.17rem;
        h3 {
          height: 0.25rem;
          font-size: 0.16rem;
          color: #333333;
          line-height: 0.25rem;
          font-weight: bold;
          margin-right: 0.11rem;
        }
        p {
          height: 0.2rem;
          font-size: 0.12rem;
          color: #999a9c;
          line-height: 0.2rem;
        }
      }
      .addSubtract_btn {
        width: 1.4rem;
        height: 0.38rem;
        background: url("../../assets/img/icon_frame_number@2x.png") no-repeat;
        background-size: 1.41rem 0.38rem;
        display: flex;
        align-items: center;
        padding: 0 0.01rem;
        .van-button {
          width: 0.36rem;
          height: 0.36rem;
          padding: 0rem;
          border: none;
          .van-button__icon {
            width: 0.14rem;
            height: 0.15rem;
            .van-icon__image {
              width: 0.14rem;
              height: 0.14rem;
            }
          }
        }
        .plus {
          width: 0.37rem;
        }
        .number {
          width: 0.66rem;
          text-align: center;
          margin: 0 0.02rem;
          border: none;
          font-size: 0.14rem;
        }
      }
    }
    .btn {
      display: flex;
      justify-content: center;
      .chosen {
        margin-top: 0.28rem;
        width: 2.72rem;
        height: 0.44rem;
        background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
        box-shadow: 0px 0.05rem 0.1rem 0px rgba(0, 83, 16, 0.04);
        border-radius: 0.22rem;
        border: none;

        font-size: 0.16rem;
        font-weight: bold;
        color: #93683d;
        line-height: 0.2rem;
      }
    }
  }
  // 分享
  .van-share-sheet {
    height: 2.04rem;
    width: 100%;
    background: #ffffff;
    border-radius: 0.2rem 0.2rem 0px 0px;
    .van-share-sheet__header {
      padding: 0;
      .van-share-sheet__title {
        margin-top: 0.15rem;
        font-size: 0.14rem;
        font-weight: bold;
        color: #333333;
      }
    }
    .van-share-sheet__options {
      padding: 0.16rem 0.23rem 0.27rem 0.23rem;
      display: flex;
      justify-content: space-between;
      .van-share-sheet__option {
        height: 0.66rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .van-share-sheet__icon {
          margin: 0;
          width: 0.39rem;
          height: 0.39rem;
        }
        .van-share-sheet__name {
          margin: 0;
          padding: 0;

          font-size: 0.12rem;
          color: #333333;
        }
      }
    }
    .van-share-sheet__cancel::before {
      height: 0.11rem;
    }
    .van-share-sheet__cancel {
      width: 100%;
      height: 0.6rem;
      font-size: 0.14rem;
      color: #333333;
      line-height: 0.49rem;
    }
  }
}
</style>
